var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"font-weight-bold"},[_vm._v("We couldn't submit this audit")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }